<div class="context-view">
  <!-- Top Section -->
  <div class="context-header">
    <div class="context-title">Auftrag {{ assignmentId() }}</div>
    <div class="f-1"></div>
    <div class="context-corner">
      <dx-button class="small-button" icon="close" (onClick)="closeAll()"></dx-button>
    </div>
  </div>
  <div class="tabs-container">
    <dx-tabs #tabsEl [dataSource]="tabs" [selectedItem]="tabs[0]" [scrollByContent]="true" [showNavButtons]="true">
      <div *dxTemplate="let item of 'item'">
        {{ item.text | translate }}
      </div>
    </dx-tabs>
  </div>

  <div class="top-cell-context">
    <dx-multi-view
      [dataSource]="tabs"
      [(selectedItem)]="tabsEl.selectedItem"
      [loop]="false"
      [animationEnabled]="true"
      [swipeEnabled]="false">
      <div *dxTemplate="let selection of 'item'">
        @switch (selection.type) {
          @case ('project-loadunits') {
            <app-assignment-project-loadunits
              [assignmentId]="assignmentId()"
              [type]="type()"
              [loadunits]="loadunits()"
              [isLoading]="isLoading()"></app-assignment-project-loadunits>
          }
          @case ('memos') {
            <app-assignment-memos [assignmentId]="assignmentId()!" [type]="type()!"></app-assignment-memos>
          }
          @case ('documents') {
            <app-assignment-documents [assignmentId]="assignmentId()!" [type]="type()!"></app-assignment-documents>
          }
          @case ('positions') {
            <app-assignment-positions [assignmentId]="assignmentId()!" [type]="type()!"></app-assignment-positions>
          }
          @case ('crates') {
            <app-assignment-crate [assignmentId]="assignmentId()!" [type]="type()!"></app-assignment-crate>
          }
          @case ('stock') {
            <app-assignment-stock
              [assignmentId]="assignmentId()!"
              [projectNos]="data()?.TrapoProjectsAssignedTo ?? []"></app-assignment-stock>
          }
          @case ('address') {
            <app-assignment-address [assignmentId]="assignmentId()!" [type]="type()!"></app-assignment-address>
          }
        }
      </div>
    </dx-multi-view>
  </div>

  <!-- Bottom Fixed Section -->
  <div class="bottom-cell-context">
    <app-assignment-detail
      [assignmentId]="assignmentId()"
      [type]="type()"
      [data]="data()"
      [subtableData]="subtableData()"></app-assignment-detail>
  </div>
</div>
